export enum LocalKeys {
  users = 'users',
  user = 'user',
  Language = 'lang',
  loggedInUser = 'loggedInUser'
}
